/**
 * We need this because for multi-domain jurisdictions, we do not know if the session is new or not.
 * To do post-login logic for multi-domain jurisdiction we need a post-login flag stored
 * in local-storage used to run the logic once after redirects end.
 */
import { isMultiLoginTarget } from '@app/multiLogin/isMultiLoginTarget';

const key = 'isNewLogin';
const value = 'true';

export function maybeMarkNewLogin(): void {
    if (isMultiLoginTarget) {
        localStorage.setItem(key, value);
    }
}

export function isNewLoginMarkSet(): boolean {
    return isMultiLoginTarget
        ? localStorage.getItem(key) === value
        : false;
}

export function clearNewLoginMark(): void {
    localStorage.removeItem(key);
}
